import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { ControlType, Property } from "../../../base/types";
import { TouUmsLinkProperties } from "./properties/TouUmsLinkProperties";
import { useGetTouUrl } from "../../page-actions/services/useTouUrl";


export const TOULinkComponent = (props: IControlAttributes) => {
    const { control } = props;
    const { properties } = useGetProperties({ bindings: control.bindings });
    const { touUrl } = useGetTouUrl()
    const target: string | undefined = properties[Property.Target];
    const title: string | undefined = properties[Property.Title];

    if (!touUrl)
        return <></>

    return (
        <>
            <div className={'menu-item'}>
                <a target={target || undefined} className={clsx('menu-link without-sub')} href={touUrl}>
                <span className='menu-title'>{title}</span>
                </a>

            </div>
        </>
    );
};


Registry.addControl({
    id: "7930854e-2f55-43e0-9587-7363af8a2d49",
    name: "TOULinkComponent",
    type: ControlType.TOULink,
    properties: TouUmsLinkProperties,
    component: TOULinkComponent,
})
